import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface UserReducer {
    session: {
        isLoggedIn: boolean;
        kundeIdUrl: string;
        kundeIdRedirectUrl: string;
        directChannel: boolean;
    };
    context: {
        bankRegNo: string;
        ssn: string;
        lastName: string;
    };
}

export const initialState: UserReducer = {
    session: {
        isLoggedIn: false,
        kundeIdUrl: '',
        kundeIdRedirectUrl: '',
        directChannel: false,
    },
    context: {
        bankRegNo: '',
        ssn: '',
        lastName: '',
    },
};

export const userReducer = (state = initialState, action: AppActions = {} as AppActions): UserReducer => {
    switch (action.type) {
        case actionTypes.FETCH_USER_SESSION_FULFILLED: {
            const { valid, kundeIdUrl, kundeIdRedirectUrl, directChannel } = action.payload;

            return {
                ...state,
                session: {
                    isLoggedIn: valid,
                    kundeIdUrl,
                    kundeIdRedirectUrl,
                    directChannel,
                },
            };
        }
        case actionTypes.FETCH_USER_CONTEXT_FULFILLED: {
            const { bankRegNo, ssn, lastName } = action.payload;

            return {
                ...state,
                context: {
                    bankRegNo: bankRegNo.value,
                    ssn,
                    lastName: lastName || '',
                },
            };
        }

        default:
            return state;
    }
};
